module.exports = __webpack_public_path__ + "img/kr-product-content1-img-2.caa97a5.png";